import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ErrorIcon from '../../static/images/error_icon.png';
import { Button } from '@mui/material';

@inject('commonStore', 'orderStore')
@observer
class ErrorBoundary extends Component {
  componentDidCatch(error) {
    this.props.commonStore.setError(error);
  }

  render() {
    const { commonStore } = this.props;
    if (commonStore.error) {
      return (
        <div className="error-container">
          <div className="error-top"></div>
          <div className="error-content">
            <div>
              <img src={ErrorIcon} alt="error" width="260" height="260" />
            </div>
            <div className="error-message">
              {commonStore.error.message ? commonStore.error.message.toString() : commonStore.error.toString()}
            </div>
            {commonStore.companyId && commonStore.storeCode ? (
              <div className="error-button">
                {!window.location.pathname.includes('lite-order') && (
                  <Button
                    component="a"
                    variant="contained"
                    color="secondary"
                    href={`/${commonStore.companyId}/${commonStore.storeCode}`}
                  >
                    HOME
                  </Button>
                )}
              </div>
            ) : undefined}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
